/**
 * As refernce Shopify documentation
 * https://shopify.dev/docs/storefronts/themes/product-merchandising/gift-cards
 *
 */

import {
  GIFT_CART_RECIPIENT_FLAG_ATTRIBUTE,
  GIFT_CART_RECIPIENT_EMAIL_ATTRIBUTE,
  GIFT_CART_RECIPIENT_NAME_ATTRIBUTE,
  GIFT_CART_MESSAGE_ATTRIBUTE,
  GIFT_CART_SEND_ON_ATTRIBUTE,
  GIFT_CART_OFFSET_ATTRIBUTE,
  GIFT_CART_RECIPIENT_FLAG_ON,
  GIFT_CART_OFFSET_DEFAULT,
  TEXTAREA_MAX_LENGTH,
  DATE_MAX_SEND_ON_DAYS,
  INPUT_NAME_MAX_LENGTH,
} from 'constants/digitalGiftCard';
import Validator from 'utils/Validator';

/**
 * Validate if a date a date string is valid
 */
export const isValidDate = dateString => {
  const dateObj = new Date(dateString);

  return !isNaN(dateObj);
};

/**
 * Build gift card line item properties object according to the Shopify schema.
 * When the shopify digital gift card product is added to the cart and completed the purchase
 *  then the gift card notificaiotn emails are sent to the recipient and buyer
 *
 * Shopify Doc: https://shopify.dev/docs/storefronts/themes/product-merchandising/gift-cards#create-a-form-to-collect-recipient-information
 *
 */
export const buildGiftCardLineItemProperties = (
  emailRecipient,
  nameRecipient,
  messageRecipient,
  sendOn
) => {
  return {
    [GIFT_CART_RECIPIENT_FLAG_ATTRIBUTE]: GIFT_CART_RECIPIENT_FLAG_ON,
    [GIFT_CART_RECIPIENT_EMAIL_ATTRIBUTE]: emailRecipient,
    [GIFT_CART_RECIPIENT_NAME_ATTRIBUTE]: nameRecipient,
    [GIFT_CART_MESSAGE_ATTRIBUTE]: messageRecipient,
    ...(isValidDate(sendOn) && { [GIFT_CART_SEND_ON_ATTRIBUTE]: formatDateYYYYMMDD(sendOn) }),
    [GIFT_CART_OFFSET_ATTRIBUTE]: GIFT_CART_OFFSET_DEFAULT, // This was extracted from the Shopify example (Dawn theme), it is hardcoded
  };
};

export const nameValidator = nameInput =>
  nameInput?.length > 0 && nameInput?.length <= INPUT_NAME_MAX_LENGTH;

export const emailValidator = emailInput => Validator.isEmail(emailInput);

export const messageValidator = messageInput =>
  messageInput?.length > 0 && messageInput?.length <= TEXTAREA_MAX_LENGTH;

/**
 * Return date formated as Shopify required
 */
export const formatDateYYYYMMDD = date => new Date(date).toISOString().slice(0, 10);

/**
 * Current date formated for HTML input type date
 */
export const currentDateYYYYMMDDFormat = () => formatDateYYYYMMDD(new Date());

/**
 * Max allowed Date on Shopify formated for HTML input type date
 */
export const maxPermitedDateYYYYMMDDFormat = () => {
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + DATE_MAX_SEND_ON_DAYS);

  return formatDateYYYYMMDD(currentDate);
};

/**
 * Shopify can only schedule a gift card to be sent up to 90 days in the future.
 */
export const dateValidator = dateInput => {
  const isDateInputValid = isValidDate(dateInput);
  const isOnPresentDate = dateInput >= currentDateYYYYMMDDFormat();
  const isBeforeMaxDate = dateInput <= maxPermitedDateYYYYMMDDFormat();

  return isDateInputValid && isOnPresentDate && isBeforeMaxDate;
};
